import { createFileRoute, useRouter } from "@tanstack/react-router";

import { LegalPage } from "@/features/content/pages";

export const Route = createFileRoute("/_app/growth/legal/")({
  component: Legal,
});

function Legal() {
  const router = useRouter();
  return (
    <LegalPage
      hrefOf={(versionId) =>
        router.buildLocation({ to: "/growth/legal/$versionId", params: { versionId } }).href
      }
      onOpen={(versionId) =>
        void router.navigate({ to: "/growth/legal/$versionId", params: { versionId } })
      }
      onNew={(from) =>
        void router.navigate({
          to: "/growth/legal/new",
          search: from === undefined ? {} : { from },
        })
      }
    />
  );
}
